import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProjectService } from '../project.service';
import { NavService } from '../../_shared/nav/nav.service';
import { ProjectViewNav } from './project-view.nav';
import { Project } from '../project';
import { SidebarOptions } from '../../_shared/nav/nav.interfaces';
import { WarehouseService } from '../warehouse.service';
import { SecondaryElementsComponent } from '../project-form-components/secondary-elements/secondary-elements.component';
import { WarehouseProfilesFormSelectorComponent } from '../project-form-components/warehouse-profiles-form/warehouse-profiles-form-selector/warehouse-profiles-form-selector.component';


@Component({
  templateUrl: './project-view.component.html',
  styleUrls: ['../project-form-components/project-form.css', './project-view.component.css']
})
export class ProjectComponent implements OnInit {
  project: Project;
  projects: Project[];
  currentWarehouseType: number;

  navOptions: SidebarOptions = undefined;
  currentStep = 1;
  loading = false;
  calculating = false;

  creating = true;
  isCalculateSecondaryElements = false;
  isCalculateProfile = false;
  @ViewChild(SecondaryElementsComponent) private secondaryElements: SecondaryElementsComponent;
  @ViewChild(WarehouseProfilesFormSelectorComponent) private warehouseProfiles: WarehouseProfilesFormSelectorComponent;
  private folderId: number;

  constructor(private route: ActivatedRoute,
    private nav: NavService,
    private projectService: ProjectService,
    private warehouseService: WarehouseService,
    private router: Router) {
    this.navOptions = {
      title: '',
      entries: [],
      nodeClass: 'padding-1'
    };
    this.project = new Project();
  }

  ngOnInit() {
    this.project = new Project();
    this.currentWarehouseType = this.project.warehouse_type;
    this.route.params.subscribe((params: Params) => {
      this.processRouteParams(+params['folder'], +params['step'], +params['id']);
    });

    this.nav.updateSidebarOptions(this.navOptions);
  }

  goToStep(i: number) {
    this.navigateToStep(i + 1)
  }

  processRouteParams(folderId: number, step: number, id: number) {
    if (Number.isInteger(id)) {
      // EDIT PROJECT
      this.creating = false;
      if (this.project.id !== id) {
        this.loading = true;
        this.navOptions.title = 'VER PROYECTO';
        this.navOptions.entries = ProjectViewNav.getProjectEditNav(
          id,
          folderId,
          _step => this.isStepDisabled(_step)
        );
        this.projectService.get(id).subscribe(project => {
          this.project = project;
          this.currentWarehouseType = this.project.warehouse_type;
          this.loading = false;
          this.currentStep = step;
          this.folderId = this.project.parent_inode;
          this.navOptions.title = this.project.name.toUpperCase();
          this.loadProjects();
        });
        this.nav.updateSidebarOptions(this.navOptions);
      }
    } else {
      // CREATE PROJECT
      this.creating = true;
      if (folderId !== this.folderId) {
        this.folderId = folderId;
        this.navOptions.title = 'PROYECTO NUEVO';
        this.navOptions.entries = ProjectViewNav.getProjectCreateNav(
          this.folderId,
          _step => this.isStepDisabled(_step)
        );
        this.nav.updateSidebarOptions(this.navOptions);
        this.loadProjects();
      }
    }

    if (!this.loading) {
      if (this.hasWarehouseType()) {
        this.currentStep = step;
      } else {
        this.navigateToStep(1);
      }
    }
  }

  isInFolder() {
    return !Number.isNaN(this.folderId);
  }

  navigateToStep(step: number) {
    if (Number.isInteger(this.project.id)) {
      if (this.isInFolder()) {
        this.router.navigate(['/proyecto', this.project.id, { step: step, folder: this.folderId }]);
      } else {
        this.router.navigate(['/proyecto', this.project.id, { step: step }]);
      }
    } else if (this.isInFolder()) {
      this.router.navigate(['/crear-proyecto', { step: step, folder: this.folderId }]);
    } else {
      this.router.navigate(['/crear-proyecto', { step: step }]);
    }
  }

  goToNextStep() {
    this.navigateToStep(this.currentStep + 1);
  }

  isNextDisabled() {
    if (this.currentStep == 4) {
      return !this.isCalculateProfile || this.isStepDisabled(this.currentStep + 1)
    } else if (this.currentStep == 5) {
      return !this.isCalculateSecondaryElements || this.isStepDisabled(this.currentStep + 1)
    }
    return this.isStepDisabled(this.currentStep + 1);
  }

  isSaveDisabled() {
    // if (this.currentStep == 5) {
    //   return !this.calcul
    // }
    return false;
  }


  isStepDisabled(step: number) {
    switch (step) {
      case 1:
        return false;
      case 2:
      case 3:
      case 4:
      case 5:
        return !this.hasWarehouseType() || this.project.name === undefined
          || this.project.name === '' || this.nameIsNotUnique(this.project.name);
      case 6:
        return this.creating;
      default:
        return true;
    }
  }

  saveProject(funct = null): void {
    this.loading = true;
    if (this.currentStep > 1) {
      this.warehouseService.update(this.project.warehouse).subscribe((warehouse) => {
        this.loading = false;
        if (funct != null) funct.call(this);
      });
    } else if (+this.project.warehouse_type === +this.currentWarehouseType) {
      if (this.project.id) this.projectService.update(this.project).subscribe((project) => {
        this.project = project;
        this.loading = false;
        if (funct != null) funct.call(this);
      });
      else {
        this.project.parent_inode = this.folderId;
        this.projectService.create(this.project).subscribe((project) => {
          this.project = project;
          this.loading = false;
          if (funct != null) funct.call(this);
        });
      }
    } else {
      if (this.project.id) {
        this.projectService.delete(this.project.id).subscribe(() => {
          this.project.parent_inode = this.folderId;
          this.projectService.create(this.project).subscribe((project) => {
            this.project = project;
            this.loading = false;
            if (funct != null) funct.call(this);
          });
        });
      } else {
        this.project.parent_inode = this.folderId;
        this.projectService.create(this.project).subscribe((project) => {
          this.project = project;
          this.loading = false;
          if (funct != null) funct.call(this);
        });
      }
    }
  }

  finishCalculation() {
    this.calculating = false;
  }

  calculateSecondaryElements() {
    // this.isCalculateSecondaryElements = true;
    this.calculating = true;
    this.secondaryElements.calcul(this, this.saveProject);
    //    this.saveProject(null);
  }

  calculateProfiles() {
    // WarehouseProfiles.calculate already update the project before calculate.
    // this.isCalculateProfile = true;
    this.calculating = true;
    this.warehouseProfiles.getProfileFormSelectorComponent().calculate(this, this.saveProject);
  }

  hasWarehouseType() {
    const type = this.project.warehouse_type;
    return Number.isInteger(type) && type >= 0 && type <= 5;
  }

  // for progress steps
  isStepDone(i) {
    return this.currentStep > i;
  }

  isCreateDisabled() {
    return this.project.name === '' || !this.hasWarehouseType();
  }

  loadProjects() {
    if (this.isInFolder()) {
      this.projectService.getFolderProjects(this.folderId).subscribe(projects => this.projects = projects);
    } else {
      this.projectService.getRootProjects().subscribe(projects => this.projects = projects);
    }
  }

  nameIsNotUnique(name) {
    for (let i = 0; this.projects && i < this.projects.length; i++) {
      if (this.projects[i].id !== this.project.id && this.projects[i].name === name) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/project/project-view/project-view.component.ts